import { getGenericError, getServerError, normalizeUnknownExceptionToError, } from '../../common/store/comments/comments-errors';
const matchError = (e) => {
    if (e instanceof Error) {
        const serverError = getServerError(e);
        return {
            error: getGenericError(e),
            baseError: e,
            ...(serverError && { serverError }),
        };
    }
    const unknownError = normalizeUnknownExceptionToError(e);
    return {
        error: { type: 'TRANSLATION', key: 'toast.error-generic' },
        baseError: unknownError,
    };
};
export const wrapServiceWithResult = (service, { customMatchError, errorEffect, }) => {
    const entries = Object.entries(service).map(([serviceCallName, serviceCall]) => [
        serviceCallName,
        async (...args) => {
            try {
                const success = await serviceCall(...args);
                return { type: 'SUCCESS', response: success };
            }
            catch (e) {
                const matched = customMatchError?.[serviceCallName]
                    ? customMatchError[serviceCallName](e)
                    : matchError(e);
                if (errorEffect) {
                    try {
                        errorEffect(matched.baseError, args);
                    }
                    catch (e) {
                        console.log('Error encountered in error effect: ', e);
                    }
                }
                return {
                    type: 'ERROR',
                    error: matched.error,
                    ...(matched.serverError && { serverError: matched.serverError }),
                };
            }
        },
    ]);
    return Object.fromEntries(entries);
};
//# sourceMappingURL=wrap-service-with-result.js.map